import React from 'react'
import moment from 'moment'
import {  withRouter } from 'react-router-dom'

import Avatar from '@material-ui/core/Avatar'
import Button from '@material-ui/core/Button'
import Divider from '@material-ui/core/Divider'
import IconArrowForward from '@material-ui/icons/ArrowForwardIos'
import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction'
import ListItemText from '@material-ui/core/ListItemText'
import Paper from '@material-ui/core/Paper'
import Text from '@material-ui/core/Typography'

function MemberSupportList(props) {
	const {section, tickets} = props

	const openTicket = (id) => {
		let url = '/member/support/' + section + '/' + id
		props.history.push({ pathname: url })
	}

	const newTicket = () => {
		let url = '/member/support/New-Ticket'
		props.history.push({ pathname: url })
	}
	
	return (
		<div style={{marginTop:20, marginBottom:150, textAlign:'right'}}>
		{(Object.keys(tickets).length) ? (
			<List style={{width:'100%', backgroundColor:'#fff', padding:5}}>
			{Object.keys(tickets).map((i, key) => {
				return (
					<div key={key}>
						<ListItem button alignItems="flex-start" onClick={() => {openTicket(i)}}>
							<ListItemAvatar>
							   <Avatar alt={tickets[i].groupName} src={tickets[i].groupThumb} style={{borderRadius:5}} />
							</ListItemAvatar>
							<ListItemText>
								<b>{tickets[i].groupName}</b>
								<Text style={{lineHeight:.8}} variant='caption' display='block' color='textSecondary'>
									{moment.unix(tickets[i].timestamp.seconds).format('MMM Do YYYY - h:mm a')}
								</Text>
								<Text style={{marginTop:5, lineHeight:1, color:'#546e7a'}}><b>{tickets[i].subject}</b></Text>
								{(tickets[i].closed) ? (
									<Text style={{lineHeight:1, color:'red'}}><b>CLOSED</b></Text>
								):(
									<Text style={{lineHeight:1, color:'#27e007'}}><b>OPEN</b></Text>
								)}
							</ListItemText>
							<ListItemSecondaryAction>
							   <IconArrowForward />
							</ListItemSecondaryAction>
						</ListItem>
						<Divider/>                
					</div>
				)
			})}
			</List>
	  	) : (
			<Paper style={{marginTop:20, padding: 20 }} >
				<div style={{padding:20, textAlign:'center'}}>
					<Text variant='caption'>NO {section.toUpperCase()} TICKETS FOUND</Text>
				</div>
			</Paper>
	  	)}   
	  		<Button size="small" style={{color:'gray', marginTop:5}} onClick={newTicket}>Open New Ticket</Button>
	  	</div>             
	)
}
export default withRouter(MemberSupportList)
